module.exports = __webpack_public_path__ + "img/refresh.ce68b4a1.svg";